<div class="inputTitle" *ngIf="!trim && !masterDashboard && label">
  <span>{{label}} <i MatSuffix matTooltip={{tooltipName}} matTooltipPosition="right" [matTooltipHideDelay]="delay"
      id="i1" class="flaticon-message" *ngIf="tooltipIcon"></i></span>
</div>

<div class="intellisense" [class.master-dashboard]="masterDashboard" [class.searchIcon]="searchIcon"
  [class.lightning]="beLight" tabindex="-1" *ngIf="isEditable" [class.errorBorderIntellisense]="errors?.length">
  <ng-select [class.has-errors]="errors?.length" [class.dualsetbox]="masterDashboardDual"
    [class.removeCross]="removeCross" appearance="outline" [(ngModel)]="data" [items]="options"
    [bindLabel]="displayField" [bindValue]="idField" [multiple]="multiple" [loading]="loading" [addTag]="setSearchValue"
    [hideSelected]="true" [closeOnSelect]="closeOnSelect" [clearSearchOnAdd]='clearSearchOnAdd'
    [placeholder]="placeholder" [searchable]="searchable" [compareWith]="compareField" [trackByFn]="trackByFn"
    [clearable]="clearable" [typeahead]="searchText" ngOptionHighlight [disabled]="disabled"
    (change)="emitChange($event)" (close)="onClose()" (open)="triggerSearch(_searchText)">

    <ng-container *ngIf="multiple">
      <ng-template ng-header-tmp>
        <div fxFlex="100" fxLayout="column" class="my-dropdown-footer text-left">
          <button *ngIf="showSelectAll" class="btn selectAllBtn" (click)="showAllData()">Select All</button>
        </div>
        <div fxFlex="100" fxLayout="column" class="my-dropdown-footer text-right">
          <div *ngIf="data != null">
            {{this.data.length}} {{this.data.length > 1 ? 'items' : 'item'}} selected
          </div>
        </div>
      </ng-template>
    </ng-container>


    <!--Input item template-->
    <ng-template ng-label-tmp let-item="item" *ngIf="defaultChip">
      <div fxFlex="100" fxLayout="column" class="managerListShow" *ngIf="labelItemTemplate == null; else labelTemplate">
        {{displayItem(item)}}
      </div>

      <ng-template #labelTemplate>
        <ng-template [ngTemplateOutlet]="labelItemTemplate" [ngTemplateOutletContext]="{ $implicit: item }">
        </ng-template>
      </ng-template>

    </ng-template>


    <!--Dropdown item template-->

    <ng-template ng-option-tmp let-item="item" let-index="index">
      <div fxFlex="100" fxLayout="column" class="managerListShow" *ngIf="itemTemplate == null; else optionTemplate"
        [ngClass]="{ 'disabled-option':  showSelectAll ? isItemSelected(item) : '' }">
        {{ displayItem(item) }}
      </div>

      <ng-template #optionTemplate>
        <ng-container [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="{ $implicit: item, index: index, idx:index }">
        </ng-container>
      </ng-template>

    </ng-template>
  </ng-select>
  <i *ngIf="masterDashboard || searchIcon" class="flaticon-search" [class.dualset]="masterDashboardDual"></i>
  <div class="dualDash" *ngIf="masterDashboardDual"> |
    <mat-form-field *ngIf="masterDashboardDual">
      <mat-select [ngModel]="masterDashboardSearchFilter" (ngModelChange)="masterDashboardFilterChange($event)">
        <mat-option value="depot">Depot</mat-option>
        <mat-option value="container">Container</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

</div>


<div class="viewLable" *ngIf="!isEditable && !multiple">
  <span *ngIf="itemTemplate == null && displayTemplate == null; else _displayTemplate">
    {{getDisplay()}}
  </span>

  <ng-template #_displayTemplate>
    <ng-container [ngTemplateOutlet]="displayTemplate ? displayTemplate : itemTemplate"
      [ngTemplateOutletContext]="{ $implicit: data }">
    </ng-container>
  </ng-template>

</div>

<div class="viewLable ulview" *ngIf="!isEditable && multiple">
  <ul>
    <li *ngFor="let item of data">
      <ng-container *ngIf="itemTemplate == null && displayTemplate == null; else _displayTemplate">
        {{displayItem(item)}}
      </ng-container>

      <ng-template #_displayTemplate>
        <ng-container [ngTemplateOutlet]="displayTemplate ? displayTemplate : itemTemplate"
          [ngTemplateOutletContext]="{ $implicit: item }">
        </ng-container>
      </ng-template>
    </li>
  </ul>

</div>

<div class="typeLabel" *ngIf="descriptiveLabel">
  <span>{{secondaryLabel}}</span>
  <mat-chip> {{descriptiveLabel}} </mat-chip>
</div>

<ul *ngIf="errors?.length" class="errorList">
  <li *ngFor="let item of errors" class="error">{{item}}</li>
</ul>